import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Context } from '../index';

const VerifiedRoute = ({ children }) => {
    const { user } = useContext(Context);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [redirectTo, setRedirectTo] = useState('');

    useEffect(() => {
        // Если пользователь не авторизован, перенаправляем на страницу входа
        if (!user.isAuth) {
            setRedirectTo('/login');
            setShouldRedirect(true);
            return;
        }

        // Если email не подтвержден, перенаправляем на страницу верификации
        if (!user.user.is_verified) {
            setRedirectTo('/verify-email');
            setShouldRedirect(true);
            return;
        }

        setShouldRedirect(false);
    }, [user.isAuth, user.user.is_verified]);

    if (shouldRedirect) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

export default VerifiedRoute; 